import { render } from "./App.vue?vue&type=template&id=9f1a2500"
const script = {}

import "./App.vue?vue&type=style&index=0&id=9f1a2500&lang=css"

import exportComponent from "/home/runner/work/coming-soon-template/coming-soon-template/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__